<div class="register-container">
    <!--Banner starts here-->
    <section id="banner" class="banner">
         <div class="container">
        <div class="banner__logos">
            <div><img src="./assets/images/ust_logowhite.png" class="banner__logosz" alt="ust-logo"> </div>
        <div class="banner__logolabel"> - Licensing App</div>
        </div>

        <div class="banner__main">
          <div class="banner__mainlabel">
            Reset Password   
          </div>
          <form 
          #f="ngForm"
          novalidate>
            <div class="row" style="margin-bottom: 20px">
              <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text inputgrouptext--custom"><i class="fa fa-lock" aria-hidden="true"></i></span>
                    </div>
                      <input
                        type="password"
                        class="form-control banner__iputpad"
                        name="password"
                        [(ngModel)]="password"
                        required
                        maxlength="32"
                        placeholder="Password" 
                      />
        
                </div>
            </div>
            </div>
          
            <div class="row" style="margin-bottom: 20px">
                <div class="col-md-12 col-lg-12 col-sm-12">
                  <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text inputgrouptext--custom"><i class="fa fa-lock" aria-hidden="true"></i></span>
                      </div>
                        <input
                          type="password"
                          class="form-control banner__iputpad"
                          name="confirmPassword"
                          [(ngModel)]="confirmPassword"
                          required
                          maxlength="32"
                          placeholder="Confirm Password"
                        />
          
                  </div>
              </div>
              </div>

            <button type="submit"  class="banner__btncustom" (click)="resetPassword()"
            >Submit</button>
            
          </form>
        </div>
      </div> 
        
        </section>
  </div>
  